import { IndexRouteGuard } from '@emfood/shared';
import { createRoute } from '@tanstack/react-router';

import { rolesIndexRouteConfig } from 'src/api/roles-config';

import SplashScreen from 'src/components/loading-screen/splash-screen';

import { rootRoute } from './root';

// Create index route
export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: () => (
    <IndexRouteGuard rolesRouteConfig={rolesIndexRouteConfig} splashScreen={<SplashScreen />} />
  ),
});
